import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col" }
const _hoisted_2 = { class: "flex flex-1 min-h-0" }
const _hoisted_3 = { class: "w-64 h-screen flex flex-col bg-gray-100 dark:bg-gray-900 border-r border-gray-300 dark:border-gray-700 transition-colors duration-200" }
const _hoisted_4 = {
  key: 0,
  class: "border-b border-gray-300 bg-transparent p-4 dark:border-gray-700"
}
const _hoisted_5 = { class: "flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-600 text-white" }
const _hoisted_6 = {
  key: 1,
  class: "p-4 border-b border-gray-300 dark:border-gray-700 bg-transparent"
}
const _hoisted_7 = {
  key: 2,
  class: "mt-3 flex-1 overflow-y-auto pb-2",
  "aria-label": "IDP navigation"
}
const _hoisted_8 = { class: "flex flex-col gap-0.5" }
const _hoisted_9 = { class: "nav-icon-wrap" }
const _hoisted_10 = { class: "nav-icon-wrap" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "nav-icon-wrap" }
const _hoisted_13 = { class: "min-w-0 flex-1" }
const _hoisted_14 = { class: "nav-hint" }
const _hoisted_15 = {
  key: 3,
  class: "mt-3 flex-1 overflow-y-auto pb-2",
  "aria-label": "Developer Tools navigation"
}
const _hoisted_16 = { class: "flex flex-col gap-0.5" }
const _hoisted_17 = { class: "nav-icon-wrap" }
const _hoisted_18 = { class: "nav-icon-wrap" }
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 0,
  class: "nav-current-dot",
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "shrink-0 p-4 border-t border-gray-300 dark:border-gray-700" }
const _hoisted_22 = {
  key: 0,
  class: "flex items-center mb-3"
}
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = { class: "text-sm font-medium text-gray-800 dark:text-white" }
const _hoisted_25 = { class: "text-xs text-gray-600 dark:text-gray-400 max-w-[180px] truncate" }
const _hoisted_26 = { class: "flex items-center justify-between mb-3 px-1" }
const _hoisted_27 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-yellow-300 absolute right-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_28 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-blue-400 absolute left-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_29 = { class: "flex-1 overflow-auto bg-white dark:bg-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewAsBanner = _resolveComponent("ViewAsBanner")!
  const _component_ServerIcon = _resolveComponent("ServerIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_FolderIcon = _resolveComponent("FolderIcon")!
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewAsBanner),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.inIdpPortal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/idp",
                class: "logo-link flex items-center gap-3 rounded-lg p-1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_ServerIcon, { class: "h-5 w-5" })
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "min-w-0" }, [
                    _createElementVNode("span", { class: "block text-lg font-bold leading-tight text-gray-900 dark:text-white" }, "IDP"),
                    _createElementVNode("span", { class: "block truncate text-[11px] text-gray-500 dark:text-gray-400" }, "Internal Developer Platform")
                  ], -1))
                ]),
                _: 1,
                __: [2]
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "flex items-center justify-center cursor-pointer p-1 logo-link"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "h-9 w-9 mr-1",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        d: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z",
                        fill: "#FFD700",
                        stroke: "#FFD700",
                        "stroke-width": "0.5"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex items-center" }, [
                      _createElementVNode("span", { class: "text-3xl font-bold text-blue-500" }, "dev"),
                      _createElementVNode("span", { class: "text-3xl font-bold text-green-500" }, "tools")
                    ])
                  ], -1)
                ])),
                _: 1,
                __: [3]
              })
            ])),
        (_ctx.inIdpPortal)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/idp",
                  class: _normalizeClass(["nav-link nav-home", { 'nav-active': _ctx.route.path === '/idp' }])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_HomeIcon, { class: "w-5 h-5" })
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "flex-1 min-w-0 truncate" }, "Overview", -1))
                  ]),
                  _: 1,
                  __: [4]
                }, 8, ["class"]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "nav-heading" }, "Explore", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.idpTools, (tool) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: tool.path
                  }, [
                    _createVNode(_component_router_link, {
                      to: tool.path,
                      class: _normalizeClass(["nav-link", { 'nav-active': _ctx.isIdpToolActive(tool.path) }])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_10, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(tool.icon), { class: "w-5 h-5" }))
                        ]),
                        _createElementVNode("span", {
                          class: "flex-1 min-w-0 truncate",
                          title: tool.name
                        }, _toDisplayString(tool.name), 9, _hoisted_11)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]),
                    (tool.path === '/idp/services')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: _ctx.workspaceTo,
                          class: _normalizeClass(["nav-link nav-link-workspace", { 'nav-active': _ctx.workspaceActive }]),
                          title: _ctx.workspaceHint
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_12, [
                              _createVNode(_component_FolderIcon, { class: "h-5 w-5" })
                            ]),
                            _createElementVNode("span", _hoisted_13, [
                              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "block truncate" }, "Workspace", -1)),
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.workspaceHint), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["to", "class", "title"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mx-3 my-4 border-t border-gray-200 dark:border-gray-700" }, null, -1)),
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-link"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "nav-icon-wrap" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "m15 18-6-6 6-6" })
                    ])
                  ], -1),
                  _createElementVNode("span", { class: "flex-1 min-w-0 truncate" }, "Developer Tools", -1)
                ])),
                _: 1,
                __: [7]
              })
            ]))
          : (_openBlock(), _createElementBlock("nav", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: _normalizeClass(["nav-link nav-home", { 'nav-active': _ctx.isHome }])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_HomeIcon, { class: "w-5 h-5" })
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "flex-1 min-w-0 truncate" }, "Home", -1))
                  ]),
                  _: 1,
                  __: [9]
                }, 8, ["class"]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "nav-heading" }, "Domains", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: section.slug,
                    to: section.directPath ?? { path: '/', hash: `#${section.slug}` },
                    class: _normalizeClass(["nav-link", { 'nav-link-current': _ctx.activeDomain === section.slug }])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_18, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(section.icon), { class: "w-5 h-5" }))
                      ]),
                      _createElementVNode("span", {
                        class: "flex-1 min-w-0 truncate",
                        title: section.name
                      }, _toDisplayString(section.name), 9, _hoisted_19),
                      (_ctx.activeDomain === section.slug)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_21, [
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: "w-8 h-8 rounded-full flex items-center justify-center mr-2",
                  style: _normalizeStyle({
                backgroundColor: _ctx.getUserColor,
                color: 'white',
                fontWeight: 'bold',
                fontSize: '0.875rem'
              })
                }, _toDisplayString(_ctx.getUserInitials), 5),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.user.name), 1),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.user.email), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Theme", -1)),
            _createElementVNode("button", {
              class: "flex items-center justify-center rounded-full w-10 h-5 bg-gray-300 dark:bg-gray-600 relative",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.theme.toggleTheme && _ctx.theme.toggleTheme(...args)))
            }, [
              (_ctx.theme.isDark.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _cache[11] || (_cache[11] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("svg", _hoisted_28, _cache[12] || (_cache[12] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                    }, null, -1)
                  ]))),
              _createElementVNode("div", {
                class: _normalizeClass(["w-4 h-4 rounded-full absolute transition-all duration-300 transform bg-gray-200", _ctx.theme.isDark.value ? 'translate-x-2' : '-translate-x-2'])
              }, null, 2)
            ])
          ]),
          _createElementVNode("button", {
            class: "w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-xs text-sm font-medium text-white bg-rose-500 dark:bg-red-600 hover:bg-rose-600 dark:hover:bg-red-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 dark:focus:ring-red-500 transition-colors duration-200",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
          }, [
            _createVNode(_component_LogoutIcon, { class: "w-4 h-4 mr-2" }),
            _cache[14] || (_cache[14] = _createTextVNode(" Logout "))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}